"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { USER_SESSION_TOUCH_MS } from "@/lib/auth/user-session-view";
import { isPlatformPath } from "@/lib/ui/platform";

export function PresenceSync() {
  const pathname = usePathname();

  useEffect(() => {
    const ping = () => {
      if (document.hidden) {
        return;
      }
      void fetch("/api/presence", {
        method: "POST",
        credentials: "same-origin",
        cache: "no-store",
      }).then((res) => {
        if (res.status === 401 && !isPlatformPath(pathname)) {
          window.location.assign("/login");
        }
      });
    };

    ping();
    const timer = window.setInterval(ping, USER_SESSION_TOUCH_MS);
    const onVisible = () => {
      if (document.visibilityState === "visible") {
        ping();
      }
    };
    document.addEventListener("visibilitychange", onVisible);

    return () => {
      window.clearInterval(timer);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, [pathname]);

  return null;
}
